import Populator from './populator.js';

export default class JavascriptPopulator extends Populator {
    constructor(input) {
        super(input);
        this.input = input;    
        this.func = this.parse(input.el.dataset.populateFunction);
        this.trigger = input.el.dataset.populateFunctionTrigger;        
        if(this.trigger === 'onload') {
            this.populate();
        }
        this.bind();
    }

    parse(funcStr) {
        try {
            return new Function("input", funcStr);
        } catch(err) {
            console.error(err);
            return () => null;
        }
    }

    bind() {
        if(this.trigger === 'hashchange') {
            window.addEventListener('hashchange', () => this.populate());
        }

        if(this.trigger === 'update') {
            const form = this.input.form;
            form?.addEventListener('onUpdate', () => this.populate());
        }
    }

    populate() {
        const value = this.func(this.input);
        super.populate(value);        
    }

    static applies(input) {
        return input.el.dataset.populateFunction !== undefined;
    }
}
